// One-time self-heal for browsers poisoned before the /login/user fix shipped.
// A stale selectedPortal of "user" (or any reserved non-portal word) makes the
// app send X-Portal: user on every API call — 404ing membership plans and
// spamming the server with 422 "The selected portal is invalid" on each load.
//
// Scrub it at startup, BEFORE the auth store, auth0 plugin, or route middleware
// read localStorage, so everything falls back to the portal brand. The "000-"
// prefix ensures this loads first alphabetically (ahead of auth0.ts).

import { isReservedPortalSlug } from '~/functions/isReservedPortalSlug';

const PORTAL_STORAGE_KEYS = ['selectedPortal', 'portal'];

// Exported for unit testing; the plugin body just invokes it on the client.
export function sanitizePersistedPortal() {
   PORTAL_STORAGE_KEYS.forEach((key) => {
      const value = localStorage.getItem(key);
      if (isReservedPortalSlug(value)) {
         console.warn(`[sanitize-portal] clearing invalid persisted portal "${value}" from localStorage.${key}`);
         localStorage.removeItem(key);
      }
   });
}

export default defineNuxtPlugin(() => {
   sanitizePersistedPortal();
});
